import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
import { BUSINESS_RESOURCE_URI as e } from "./business.js";
const s = "food_menus";
class u extends n {
  /**
   * Checks if food menus are available for a given business.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/business/${businessId}/is_food_menus_available`
   *
   * @param {string} businessId - The ID of the business to check.
   * @returns {Promise<boolean>} A promise that resolves to a boolean indicating whether food menus are available.
   */
  isFoodMenusAvailable = async (t) => {
    const { data: a } = await this.get(
      `${e}/${t}/is_food_menus_available`
    );
    return a;
  };
  /**
   * Fetches the food menu for a specific business.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/business/${businessId}/food_menus`
   *
   * @param {string} businessId - The ID of the business for which to fetch the food menu.
   * @returns {Promise<FoodMenuGetDataType>} A promise that resolves to the food menu data.
   */
  getFoodMenu = async (t) => {
    const { data: a } = await this.get(
      `${e}/${t}/${s}`
    );
    return a;
  };
  /**
   * Creates or updates a food menu for a given business.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/business/${businessId}/food_menus`
   *
   * @param {string} businessId - The ID of the business for which the food menu is being created or updated.
   * @param {Array<FoodMenuSectionType>} sections - An array of food menu sections to be included in the menu.
   * @returns {Promise<FoodMenuGetDataType>} A promise that resolves to the data of the created or updated food menu.
   */
  createUpdateFoodMenu = async (t, a) => {
    const { data: o } = await this.post(
      `${e}/${t}/${s}`,
      { menus: a }
    );
    return o;
  };
}
export {
  u as FoodMenu
};
